import { render, staticRenderFns } from "./FamousDoctor.vue?vue&type=template&id=8528c6d4&scoped=true"
import script from "./FamousDoctor.vue?vue&type=script&lang=js"
export * from "./FamousDoctor.vue?vue&type=script&lang=js"
import style0 from "./FamousDoctor.vue?vue&type=style&index=0&id=8528c6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8528c6d4",
  null
  
)

export default component.exports